module.exports = __webpack_public_path__ + "img/hero-school_s@2x.b0633cd1.webp";